const SubscriberValidation = {
  data(){
    return{
      submited: false,
      requiredFields: [],
      objectsToValidate: [],
      passed: false
    }
  },
  methods: {
    messageClass(property, item){
      if(typeof item[property] === 'object' && item[property].constructor === Array && this.requiredFields.includes(property)){
        return{
          'md-invalid': item[property].length == 0
        }
      } else{
        if(property != 'email' && property != 'oib'){
          /*if(this.requiredFields.includes(property) && (item[property] == '' || item[property] === undefined) && this.submited){
            console.error(`Validation Error - ${property}`)
          }*/
          return{
            'md-invalid': this.requiredFields.includes(property) && (item[property] == '' || item[property] === undefined) && this.submited
          }
        }
        if(property == 'email'){
          let isEmail = true;
          if(item[property] !== undefined){
            if(item[property].indexOf('@') < 0){
              isEmail = false;
            }
          }
          return{
            'md-invalid': this.requiredFields.includes(property) && (item[property] == '' || item[property] === undefined || !isEmail) && this.submited
          }
        }
        if(property == 'oib'){
          let isOib = true;
          if(item[property] !== undefined){
            if(item[property].length < 11 || isNaN(item[property])){
              isOib = false;
            }
          }
          return{
            'md-invalid': this.requiredFields.includes(property) && (item[property] == '' || item[property] === undefined || !isOib) && this.submited
          }
        }
      }
    },

    clearForm(){
      this.submited = false;
      this.$store.state.selectedObject = {};
    },

    formSubmitted(){
      let key = null;
      this.passed = true;
      this.submited = true;

      this.objectsToValidate.forEach((item) =>{
        for(key in item){
          if(this.messageClass(key, item)['md-invalid']){
            this.passed = false;
          }
        }
      })
    },
  }
}

export default SubscriberValidation;


// WEBPACK FOOTER //
// ./src/mixins/subscriber-validator.js